export default "__VITE_ASSET__BGbK2Wbj__"